import React, {Component} from 'react'
import Dropzone from 'react-dropzone'
import {Button, Col, ControlLabel, FormControl, FormGroup, Glyphicon} from 'react-bootstrap'
import {getLink} from "../../utils/files";

export default class FileField extends Component {

	constructor(props) {
		super(props);

		this.onOpenClick = this.onOpenClick.bind(this);
		this.onCancelClick = this.onCancelClick.bind(this);
		this.onDrop = this.onDrop.bind(this);

		this.state = {
			files: [],
			drag: false,
		}
	}

	onDrop(filesToUpload) {
		const files = this.state.files.concat(filesToUpload);
		this.setState({
			files: files,
			drag: false,
		});

		this.props.input.onChange(files)
	}

	onOpenClick(e) {
		this.refs.dropzone.open()
		e.stopPropagation();
	}

	onCancelClick(file) {
		if (!this.state.files.filter) {
			return;
		}
		const files = this.state.files.filter((f) => f !== file);
		this.setState({files});
		this.props.input.onChange(files)
	}

	onToggleClick(file, doRemove) {
		if (!this.state.files.filter) {
			return;
		}
		const files = this.state.files.filter((f) => f.fileId !== file.fileId);
		if (doRemove) {
			files.push({fileId: file.fileId, isRemove: true});
		}
		this.setState({files});
		this.props.input.onChange(files)
	}


	render() {
		const {
			label,
			feedbackIcon,
			input,
			meta: {error, warning, touched},
			disabled,
			emptyText,
			currentFiles,
			multiple,
			accept
		} = this.props;

		let message;

		if (touched && (error || warning)) {
			message = <span className="help-block">{error || warning}</span>
		}

		const dzOptions = {
			multiple: multiple,
			disablePreview: false
		};
		if (accept) {
			dzOptions.accept = accept
		}
		const {files, drag} = this.state;
		const newFiles = files.filter((f) => !f.fileId);

		return (
			<FormGroup controlId={input.name}>
				{label !== null && <Col xs={2} componentClass={ControlLabel}>{label}</Col>}
				<Col xs={label !== null ? 10 : 12}>
					{currentFiles && currentFiles.length > 0 && <div className={"dropzone-current"}>
						{currentFiles.map((f, i) => {
							const isRemoved = (this.state.files.filter && files.filter(file => file.fileId === f.fileId).length);
							return <div key={i} className="file-placeholder" style={isRemoved ? {textDecoration: "line-through"} : null}>
								<a target={'_blank'} href={getLink(f.guid, f.fileName)} className="btn btn-link">{f.fileName} ({Math.round(f.fileSize / 1024)} kB)</a>
								<Button type="button" bsStyle={isRemoved ? 'info' : 'danger'} bsSize={"xs"}
									onClick={() => this.onToggleClick(f, !isRemoved)}><Glyphicon glyph={isRemoved ? "refresh" : "trash"}/> </Button>
							</div>
						})}
					</div>}
					{(!currentFiles || currentFiles.length <= 0) && !files.length
						&& <div style={{paddingTop: "7px"}}>
							<em className="file-placeholder text-muted">({emptyText || 'není'})</em>
						</div>}
					{newFiles.length > 0 && <div className={"dropzone-files"}>
						{newFiles.map((f, i) => {
							return <div key={i} className="file-placeholder">
								<a target={'_blank'} href={f.preview} className="btn btn-link">{f.name} ({Math.round(f.size / 1024)} kB)</a>
								<Button type="button" bsStyle="warning" bsSize={"xs"} onClick={() => this.onCancelClick(f)}><Glyphicon glyph="trash"/> </Button>
							</div>
						})}
					</div>}
					{!disabled && <div>
						<Dropzone
							ref="dropzone"
							className="dropzone"
							name={input.name}
							onDrop={this.onDrop}
							onDragEnter={() => this.setState({drag: true})}
							onDragLeave={() => this.setState({drag: false})}
							{...dzOptions}
						>
							<section style={drag ? {backgroundColor: "#eee"} : null}>
								Přiložte soubory přetažením nebo kliknutím.
							</section>
						</Dropzone>
						{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
						{message}
					</div>}
				</Col>
			</FormGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/form/FileField.js